/* Native artwork enlargement, shared with the existing carousel and its controls. */
(function () {
  'use strict';
  document.querySelectorAll('[data-gallery-story]').forEach(function (gallery) {
    var dialog = gallery.querySelector('[data-gallery-dialog]');
    var trigger = gallery.querySelector('[data-gallery-expand]');
    var enlarged = gallery.querySelector('[data-gallery-enlarged]');
    var counter = gallery.querySelector('[data-gallery-position]');
    var track = gallery.querySelector('[data-gallery-track]');
    var thumbs = gallery.parentNode.querySelector('[data-gallery-thumbs]');
    if (!dialog || !trigger || !track || !thumbs) return;
    var previousOverflow = '';
    var current = '';
    function sync() {
      var active = track.querySelector('.is-active');
      if (!active) return;
      var id = active.getAttribute('data-slide');
      var selected = Array.from(thumbs.querySelectorAll('[data-goto]')).find(function (button) {
        return button.getAttribute('data-goto') === id;
      });
      if (selected) {
        var left = selected.offsetLeft - thumbs.offsetLeft;
        if (left < thumbs.scrollLeft || left + selected.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth) {
          thumbs.scrollLeft = left - (thumbs.clientWidth - selected.offsetWidth) / 2;
        }
      }
      if (!dialog.open || current === id) return;
      current = id;
      enlarged.replaceChildren();
      var artwork = active.querySelector('.offline-art, .buy__slide-img');
      if (artwork) enlarged.appendChild(artwork.cloneNode(true));
      counter.textContent = (Array.from(track.children).indexOf(active) + 1) + ' / ' + track.children.length;
    }
    trigger.addEventListener('click', function () {
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      gallery.setAttribute('data-gallery-paused', '');
      current = '';
      dialog.showModal();
      sync();
      dialog.querySelector('[data-gallery-close]').focus({preventScroll: true});
    });
    function close() { dialog.close(); }
    dialog.querySelector('[data-gallery-close]').addEventListener('click', close);
    dialog.addEventListener('click', function (event) { if (event.target === dialog) close(); });
    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = previousOverflow;
      gallery.removeAttribute('data-gallery-paused');
      trigger.focus({preventScroll: true});
    });
    function navigate(direction) {
      gallery.querySelector(direction < 0 ? '[data-gallery-prev]' : '[data-gallery-next]').click();
      sync();
    }
    dialog.querySelector('[data-gallery-large-prev]').addEventListener('click', function () { navigate(-1); });
    dialog.querySelector('[data-gallery-large-next]').addEventListener('click', function () { navigate(1); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); navigate(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    new MutationObserver(sync).observe(track, {subtree: true, attributes: true, attributeFilter: ['class']});
  });
})();
